import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker as MaterialDatePicker } from '@material-ui/pickers';
import { formatDate } from '~/common';
import '../styles/DatePickerField.scss';

const DatePickerField = (props) => {
    return (
        <MaterialDatePicker className="date-field" label={props.label} invalidDateMessage="" emptyLabel=""
                            inputVariant="outlined" format="dd.MM.yy"
                            variant="inline" disableToolbar={true} autoOk={true} fullWidth={true}
                            InputLabelProps={{shrink: true}}
                            value={props.value} onChange={(value) => props.setValue(value)}
                            error={props.error}
                            helperText={props.helperText}
                            onFocus={props.onFocus}
                            placeholder={(props.placeholder.length > 0) ? props.placeholder : formatDate(new Date())}
        />
    );
};

DatePickerField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
    setValue: PropTypes.func.isRequired,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
};

DatePickerField.defaultProps = {
    error: false,
    helperText: '',
    placeholder: '',
};

export default DatePickerField;
